export default theme => ({
  disabled: {
    color: theme.palette.disabled.light,
  },
});
